import { render, staticRenderFns } from "./DetailPanneau.vue?vue&type=template&id=933bf530"
import script from "./DetailPanneau.vue?vue&type=script&lang=js"
export * from "./DetailPanneau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports